<script setup lang="ts">
import { CheckCheck } from '@lucide/vue'
import type { PublicNotificationDto } from '~~/shared/types/notification'

defineProps<{ notifications: PublicNotificationDto[]; pending?: boolean }>()
const analytics = useAnalytics()
const emit = defineEmits<{ open: [notification: PublicNotificationDto]; readAll: [] }>()
function viewAll() {
  analytics.trackEvent('notification_action', { action: 'view_all' })
  analytics.setNavigationSource('notification')
}
</script>

<template>
  <section
    class="notification-dropdown"
    aria-label="Notifications récentes"
  >
    <header>
      <div><strong>Notifications</strong><small>Vos dernières actualités Morning</small></div>
      <UiButton
        variant="ghost"
        tone="neutral"
        size="sm"
        type="button"
        @click="emit('readAll')"
      >
        <CheckCheck :size="15" />Tout lire
      </UiButton>
    </header>
    <div
      v-if="pending && !notifications.length"
      class="notification-empty"
    >
      Chargement…
    </div>
    <div
      v-else-if="!notifications.length"
      class="notification-empty"
    >
      Vous n’avez aucune notification.
    </div>
    <div
      v-else
      class="notification-dropdown-list"
    >
      <NotificationsNotificationItem
        v-for="item in notifications.slice(0, 8)"
        :key="item.id"
        :notification="item"
        compact
        @open="emit('open', $event)"
      />
    </div>
    <footer>
      <NuxtLink
        to="/notifications"
        @click="viewAll"
        >Consulter toutes les notifications</NuxtLink
      >
    </footer>
  </section>
</template>
